import { Routes } from '@angular/router';
import { LoginPageComponent } from './core/components/login/login-page/login-page.component';
import { HomeComponent } from './core/components/home/home.component';
import { CompanySearchComponent } from './features/company-search/components/company-search/company-search.component';
import { TestComponent } from './core/components/test/test.component';
import { ThematicHomeComponent } from './features/thematic-search/components/thematic-home/thematic-home.component';
import { CustomSearchComponent } from './features/thematic-search/components/custom-search/custom-search.component';
import { ThemeCatalogueComponent } from './features/thematic-search/components/theme-catalogue/theme-catalogue.component';
import { IdeaGenerationHomeComponent } from './features/idea-generation/components/idea-generation-home/idea-generation-home.component';
import { ResultsMainPageComponent } from './features/results/components/results-main-page/results-main-page.component';
import { AuthGuard } from './core/guards/auth.guard';
import { UsersTableComponent } from './features/admin-panel/components/users-table/users-table.component';
import { BenchmarkManagementComponent } from './features/admin-panel/components/benchmark-management/benchmark-management.component';
import { AdminPanelAuthGuard } from './core/guards/admin-panel-auth.guard';
import { DemoChatbotComponent } from './features/demo-bot/chatbot/chatbot.component';
import { InternalToolsAuthGuard } from './core/guards/internal-tools.guard';
import { ChatbotComponent } from './features/pro-bot/chatbot/chatbot.component';
import { MonitoringDashboardComponent } from './features/monitoring/components/monitoring-dashboard/monitoring-dashboard.component';
import { SiaStatisticsComponent } from './features/internal-tools/sia-statistics/sia-statistics.component';
import { UnsubscribeComponent } from './core/components/unsubscribe/unsubscribe.component';

export const routes: Routes = [
  { path: '', component: LoginPageComponent },
  { path: 'login', component: LoginPageComponent },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: 'home', component: HomeComponent,canActivate: [AuthGuard] },
  { path: 'company-search', component: CompanySearchComponent ,canActivate: [AuthGuard]},
  { path: 'thematic-search', component: ThematicHomeComponent,canActivate: [AuthGuard] },
  { path: 'thematic-search/custom', component: CustomSearchComponent,canActivate: [AuthGuard] },
  { path: 'thematic-search/catalogue', component: ThemeCatalogueComponent,canActivate: [AuthGuard] },
  { path: 'idea-generation', component: IdeaGenerationHomeComponent ,canActivate: [AuthGuard]},
  { path: 'results', component: ResultsMainPageComponent,canActivate: [AuthGuard] },
  { path: 'monitoring', component: MonitoringDashboardComponent, canActivate: [AuthGuard] },
  { path: 'admin-panel', component: UsersTableComponent,canActivate: [AdminPanelAuthGuard] },
  { path: 'admin-panel/benchmarks', component: BenchmarkManagementComponent,canActivate: [AdminPanelAuthGuard] },
  { path: 'sia-statistics', component: SiaStatisticsComponent, canActivate: [InternalToolsAuthGuard] },
   {path:'pro-bot', component:ChatbotComponent, canActivate:[InternalToolsAuthGuard]},
  // {path:'demo-bot', component:DemoChatbotComponent}



];

